import React from 'react';

import { Stack, Tag, VariantProps } from '@eluve/components';

import { styles } from './MedicalCode';

type MedicineDetailsProps = {
  name: string;
  ingredients: string;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  onClick?: () => void;
  type?: VariantProps<typeof styles>['type'];
};

export const MedicineDetails = React.forwardRef<
  HTMLDivElement,
  MedicineDetailsProps
>(({ name, ingredients, onClick, startAdornment, endAdornment, type }, ref) => {
  const { container, content, frame } = styles({
    clickable: Boolean(onClick),
    type,
  });

  return (
    <Stack
      align="center"
      className={container()}
      fullWidth={false}
      inline
      ref={ref}
      onClick={onClick}
      gap={3}
      direction="horizontal"
    >
      {startAdornment && startAdornment}

      <Stack gap={2} direction="horizontal">
        {ingredients && (
          <Tag label={ingredients} size="xs" color="yellow" subtle={false} />
        )}
        <div
          className={content({
            className: 'text-xs font-medium text-text-primary',
          })}
        >
          <p>{name}</p>
        </div>
      </Stack>

      {endAdornment && endAdornment}

      <div className={frame()} />
    </Stack>
  );
});

MedicineDetails.displayName = 'MedicineDetails';
